import React, { useState, useEffect } from 'react';
import { IState, ReduxMap } from '../../redux/redux';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { IEventResultsInfo, IResultInfo } from './EventResultTypes';
import { toast } from 'react-toastify';
import { Selectable } from '../../utils/CommonTypes/CommonTypes';
import { FormatDate } from '../../utils/Tools';
import Icon, { IconType } from '../Icon/Icon';

interface IProps extends IState {}

const EventResults = (props: IProps) => {
  const [info, setInfo] = useState<IResultInfo>();
  const [selectedEventId, setSelectedEventId] = useState<number>();
  const [eventResults, setEventResults] = useState<IEventResultsInfo>();
  const [selectable, setSelectable] = useState<Selectable[]>([]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (eventResults) {
    }
  }, [eventResults]);

  const init = () => {
    //call server get info
    store.server.getApi<ServerResponse<IResultInfo>>(`../Results/Info`).then((x) => {
      if (x.Success) {
        setInfo(x.Value);
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const loadEventResults = (eventId: number) => {
    //call server get event results
    store.server.getApi<ServerResponse<IEventResultsInfo>>(`../Results/ResultsFor/${eventId}`).then((x) => {
      if (x.Success) {
        setEventResults(x.Value);
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  return (
    <>
      <div className="flex-between">
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-4">Event</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                value={selectedEventId}
                onChange={(e) => {
                  const val = parseInt(e.target.value);
                  setSelectedEventId(val);
                  loadEventResults(val);
                }}>
                <option value="">Select Event</option>
                {info?.events.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.fairName} - {FormatDate(x.awardDate, 'date')}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <br/>
      <hr/>
      <br/>
      {selectedEventId && eventResults ? <>
        <h3>Event Results for {info.events.find(x=>x.id === selectedEventId)?.fairName}</h3>
        {eventResults.participants.length === 0 ? 
          <div className='alert alert-info'>
            <h3><Icon type={IconType.info}/> No Results</h3>
            No results have been entered for this event.</div>
          :
          <>
            <table className="table table-striped table-bordered table-condensed">
              <thead>
                <tr>
                  <th>Participant</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th>School</th>
                  <th>Award</th>
                </tr>
              </thead>
              <tbody>
                {eventResults.participants.map((x, i) => (
                  <tr key={i}>
                    <td>{x.firstName} {x.lastName}</td>
                    <td>{x.title}</td>
                    <td>{x.category}</td>
                    <td>{x.school}</td>
                    <td>{x.award}
                        <br/>
                      {!x.specialAwards || x.specialAwards.length === 0 ? ''
                        : 
                        <ul className='none'>
                          {x.specialAwards.map((sa, j) => (
                            <li key={j}>{sa.award} {sa.subType && <>({sa.subType})</>}</li>
                          ))}
                        </ul>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        }
      </>
      :
      <>
        <div className='alert alert-info'>
            <h3><Icon type={IconType.warning}/> No Event Selected</h3>
            Select an event to view results.</div>
      </>}

    </>
  );
};

export default ReduxMap(EventResults);
